import { useMemo } from 'react';

import { ProductCardType } from '@shared/types/product';

export const useOrderPaymentPlate = (products: ProductCardType[]) => {
  const selectedCartProductValues = useMemo(() => Object.values(products).filter((el) => el.selected), [products]);

  const quantity = selectedCartProductValues.length;

  const outStock = useMemo(
    () => selectedCartProductValues.some((el) => el.remainder === undefined || +el.remainder === 0),
    [selectedCartProductValues]
  );

  const totalAmount = useMemo(
    () =>
      selectedCartProductValues.reduce(
        (acc, { price = 0, quantity = 1, remainder }) => (remainder && +remainder > 0 ? acc + price * quantity : acc),
        0
      ),
    [selectedCartProductValues]
  );

  return {
    selectedCartProductValues,
    quantity,
    outStock,
    totalAmount
  };
};
